import { css } from 'styled-components';

export const absoluteDivStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;

  width: 100%;
  height: 100%;
`;
